import React from 'react';
import { useSelector } from 'react-redux';
import { Stack, Card, CardHeader, CardContent, TextField } from '@mui/material';


export default function TeacherMailFieldsZS ({ formik }) {
  const { seasonIdentifier } = useSelector(state => state.app);

  return (
    <Card>
      <CardHeader title="Mail nauczyciele" />
      <CardContent>
        <Stack spacing={2}>
          <TextField name="coordinator_teacher_mail" label="Koordynator" variant="outlined" onChange={formik.handleChange} value={formik.values.coordinator_teacher_mail}/>
          {seasonIdentifier == 'l_23_zs' ? <TextField name="teacher_mail_p8" label="Punkt 8" variant="outlined" multiline minRows={3} onChange={formik.handleChange} value={formik.values.teacher_mail_p8}/> : null}
          {seasonIdentifier != 'l_25_zs' ? <TextField name="trip_teacher_mail" label="Wycieczka" variant="outlined" multiline minRows={3} onChange={formik.handleChange} value={formik.values.trip_teacher_mail}/> : null}
          <TextField name="accomodation_teacher_mail" label="Zakwaterowanie" variant="outlined" multiline minRows={3} onChange={formik.handleChange} value={formik.values.accomodation_teacher_mail}/>
        </Stack>
      </CardContent>
    </Card>
  );
};
